import axios from "axios";
import { message } from "ant-design-vue";
const querystring = require("querystring");
export default class Request {
  constructor() {
    console.log("process.env.NODE_ENV:", process.env.NODE_ENV);
    console.log("process.env.BASE_URL:", process.env.VUE_APP_URL);
    console.log("process.env.DEBUG", process.env.VUE_APP_DEBUG);
    this.config = {
      //基础URL
      // baseURL: process.env.VUE_APP_URL||'',
      baseURL: process.env.VUE_APP_URL || "",
      //请求延时时间
      timeout: 10000,
      //自定义请求头内容
      headers: {
        //'content-type':'application/x-www-form-urlencoded;charset=UTF-8' ,
        "Content-Type": "application/json;charset=UTF-8",
        //    token:this.token
      },
      //请求数据类型包括  'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
      responseType: "json",
      //无论请求为何种类型，在params中的属性都会以key=value的格式在urlzhong拼接
      params: {},
      // transformRequest: [
      //   function (data) {
      //     return querystring.stringify(data);
      //   },
      // ],
      // 只适用于 POST,PUT,PATCH，transformRequest` 允许在向服务器发送前，修改请求数据。后面数组中的函数必须返回一个字符串，或 ArrayBuffer，或 Stream
      transformResponse: [
        function (result) {
          let data = JSON.parse(result);
          console.log("data", data);
          if (data.code == 200) {
            return data;
          } else if (data.code == -2) {
            return data;
          } else {
            //开发环境
            if (process.env.NODE_ENV == "development") {
              // return data;
            } else {
              //登录失败后跳转微信登录
              // window.location.href=data.data.url
            }
          }
        },
      ], //transformResponse` 在传递给 then/catch 前，允许修改响应数据
      validateStatus: function (status) {
        return status < 400; //状态码小于400时均为成功（返回true）
      }, //validateStatus` 定义对于给定的HTTP 响应状态码是 resolve 或 reject  promise 。如果 `validateStatus` 返回 `true` (或者设置为 `null` 或 `undefined`)，promise 将被 resolve; 否则，promise 将被 rejecte
      //取消请求，下文详细说明
    };
    //this.config
    this.axios = axios.create(this.config);
  }
  //返回一个Promise(发送post请求)
  fetchPost(url, params = {}, token) {
    params = Object.assign(
      {
        //  device:'wx'
      },
      params
    );
    return new Promise((resolve, reject) => {
      this.axios
        .post(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          message.error("网络异常，请稍后再试");
        });
    });
  }

  //返回一个Promise(发送get请求)
  fetchGet(url, param, token) {
    return new Promise((resolve, reject) => {
      this.axios
        .get(url, {
          params: param,
          //   headers:{

          //     token:token||this.token
          //   }
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          message.error("网络异常，请稍后再试");
        });
    });
  }
}

export const request = new Request();
